import { Star } from "lucide-react";
import { useLang } from "@/i18n";

export default function ReviewCard({ review, index }) {
    const { t } = useLang();
    return (
        <figure
            data-testid={`review-card-${index}`}
            className="flex w-full shrink-0 flex-col rounded-2xl bg-cream p-7 shadow-[0_8px_30px_rgba(45,51,25,0.06)] md:w-[360px] md:snap-start"
        >
            <div className="flex items-center gap-1" aria-label={`${review.rating} de 5 estrellas`}>
                {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                        key={s}
                        className={`h-4 w-4 ${s <= review.rating ? "fill-amber text-amber" : "text-sand-border"}`}
                        strokeWidth={1.5}
                    />
                ))}
            </div>
            <blockquote className="mt-4 flex-1 font-display text-lg font-light italic leading-relaxed text-ink">
                “{review.text}”
            </blockquote>
            <figcaption className="mt-6 flex items-center justify-between border-t border-sand-border pt-4">
                <div>
                    <p className="text-sm font-medium text-ink">{review.name}</p>
                    <p className="text-xs font-light text-ink-muted">{t.reviews.verified} · {review.date}</p>
                </div>
                <span className="text-[10px] font-medium uppercase tracking-[0.2em] text-ink-muted/70">Google</span>
            </figcaption>
        </figure>
    );
}
